module.exports = __webpack_public_path__ + "9bfdcad12729324eee6d4350c76bf6b8.png";